import {
  BaseChartProps,
  ChartProps,
  DonutChartProps,
  GaugeChartProps,
  LineChartProps,
  PieChartProps
} from '../types/chartProps';

function hasKindProperty(props: ChartProps): props is ChartProps {
  return 'kind' in props;
}

function hasSeriesProperty(props: ChartProps): props is ChartProps {
  return 'series' in props;
}

function doesNotHaveAxisProperty(props: ChartProps): props is ChartProps {
  return !('xAxis' in props) && !('yAxis' in props);
}

export function isLineChartProps(props: ChartProps): props is LineChartProps {
  return hasKindProperty(props) && props.kind === 'line';
}

export function isBarChartProps(props: ChartProps): props is LineChartProps {
  return hasKindProperty(props) && props.kind === 'bar';
}

export function isPieChartProps(props: ChartProps): props is PieChartProps {
  return (
    (hasKindProperty(props) && props.kind === 'pie') || (hasSeriesProperty(props) && doesNotHaveAxisProperty(props))
  );
}

export function isDonutChartProps(props: ChartProps): props is DonutChartProps {
  return (
    (hasKindProperty(props) && props.kind === 'donut') || (hasSeriesProperty(props) && doesNotHaveAxisProperty(props))
  );
}

export function isGaugeChartProps(props: ChartProps): props is GaugeChartProps {
  return (
    (hasKindProperty(props) && props.kind === 'gauge') || (hasSeriesProperty(props) && doesNotHaveAxisProperty(props))
  );
}

export function isBaseChartProps(props: ChartProps): props is BaseChartProps {
  return 'xAxis' in props && 'yAxis' in props;
}
